import type {PricingChannels} from "../constant";

export default function buildChannels<T extends PricingChannels>(
    listing: {channels?: Partial<Record<T, unknown>>} = {}
) {
    return listing.channels ? Object.keys(listing.channels) : [];
}
